var utils = require('frontend-controller/lib/utils');

module.exports = {
	model: {
		nrOfElements: {
			nrOfSelectedElements: 0,
			nrOfShownElements: 0,
			nrOfMatchingElements: 0,
			nrOfElements: 0,

			sizeOfSelectedElements: 0,
			sizeOfShownElements: 0,
			sizeOfMatchingElements: 0,
			sizeOfElements: 0
		}
	},

	methods: {
		updateNrOfElements: function(nrOfElements){
			this.model.nrOfElements = nrOfElements;
			this.model.nrOfElements.formattedSizeOfSelectedElements 	= utils.fileSize.format(this.model.nrOfElements.sizeOfSelectedElements, 2);
			this.model.nrOfElements.formattedSizeOfShownElements 		= utils.fileSize.format(this.model.nrOfElements.sizeOfShownElements, 2);
			this.model.nrOfElements.formattedSizeOfMatchingElements 	= utils.fileSize.format(this.model.nrOfElements.sizeOfMatchingElements, 2);
			this.model.nrOfElements.formattedSizeOfElements 			= utils.fileSize.format(this.model.nrOfElements.sizeOfElements, 2);
			this.refresh();
		}
	}
}